import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=136dfb63&scoped=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=136dfb63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dfb63",
  null
  
)

export default component.exports